/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Faq_DescriptionInputs */

const he_seo_faq_description = /** @type {(inputs: Seo_Faq_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תשובות לשאלות נפוצות על Pricedrop - איך עוקבים אחרי מחירים, שימוש בתוסף, דיוק הנתונים ועוד.`)
};

const en_seo_faq_description = /** @type {(inputs: Seo_Faq_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answers to common questions about Pricedrop - how to track prices, extension usage, data accuracy and more.`)
};

/**
* | output |
* | --- |
* | "Answers to common questions about Pricedrop - how to track prices, extension usage, data accuracy and more." |
*
* @param {Seo_Faq_DescriptionInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const seo_faq_description = /** @type {((inputs?: Seo_Faq_DescriptionInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Faq_DescriptionInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_seo_faq_description(inputs)
	return en_seo_faq_description(inputs)
});